import { useQuery } from "@tanstack/react-query";
import { getProductMedia } from "../api/endpoints";
import { qk } from "../api/queryKeys";

export default function useProductMedia(productId) {
  return useQuery({
    queryKey: qk.products.media(productId),
    queryFn: ({ signal }) => getProductMedia(productId, { signal }),
    enabled: !!productId,
  });
}
